import {
  ActionType,
  IStressSituationResponse,
} from "models/stressCheck/stressSituation";

export const stressSituationAction = () => {
  return {
    type: ActionType.STRESS_SITUATION,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.STRESS_SITUATION_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IStressSituationResponse) => {
  return {
    type: ActionType.STRESS_SITUATION_SUCCESS,
    payload,
  };
};
